import { render } from "./MatchingList.vue?vue&type=template&id=922c391e&ts=true"
import script from "./MatchingList.vue?vue&type=script&lang=ts"
export * from "./MatchingList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__